import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/contact";
import { SITE } from "@/data/site";

export const WhatsAppFab = () => {
  const href = buildWhatsAppLink(`Hello ${SITE.brand}, I'd like to enquire about your fireclay sinks.`);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 px-4 py-3 bg-[#1A1B2E] text-white hover:bg-[#282760] transition-colors shadow-[0_4px_24px_rgba(0,0,0,0.15)]"
    >
      <MessageCircle size={18} />
      <span className="text-xs uppercase tracking-[0.2em] hidden sm:inline">
        WhatsApp
      </span>
    </a>
  );
};
